import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { EditTimeZoneReference } from 'edit/reference/EditTimeZoneReference';

const DefaultTimezoneFields: React.FC<{
  selectedKey: string;
  setSelectedKey: (v: string) => void;
  formData: any;
  onTimezoneChange: (value: string) => void;
  validationMessage: string;
}> = ({ selectedKey, setSelectedKey, formData, onTimezoneChange, validationMessage }) => {
  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId="defaultTimezoneKey">
        <Form.Label column sm="2">
          Key
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="key" value={selectedKey} onChange={(e) => setSelectedKey(e.target.value)} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="mb-3" controlId="defaultTimezoneValueTimezone">
        <Form.Label column sm="2">
          Timezone
        </Form.Label>
        <Col sm="10">
          <EditTimeZoneReference value={formData?.timezone || null} onChange={(timezone) => onTimezoneChange(timezone ?? '')} />
          {validationMessage && <Form.Text className="text-danger">{validationMessage}</Form.Text>}
        </Col>
      </Form.Group>
    </>
  );
};

export default DefaultTimezoneFields;
